import React, { FunctionComponent } from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';
import { Main } from 'components';
import { Final } from 'containers/Steps';

const Overview: FunctionComponent<RouteComponentProps> = ({ match: { path } }) => (
  <Switch>
    <Route exact path="/overview/download" component={Final} />
    <Route path={path} component={Main} />
  </Switch>
);

export default Overview;
